<template>
  <div class="share-drawer show" :class="{ 'show-all': drawerToggle }" @touchmove.stop>
    <h6 class="share-drawer-t" v-show="drawerToggle">通过以下途径邀请</h6>
    <div class="share-drawer-content d-flex align-items-center flex-wrap">
      <span @click="shareJump('wechat')"><i class="wechat-icon"></i>微信</span>
      <span @click="shareJump('wechatMoments')"
        ><i class="friend-circle-icon"></i>朋友圈</span
      >
      <span @click="shareJump('invite')"
        ><i class="qrcode-icon"></i>面对面邀请</span
      >
      <span @click="onToggleChange(true)" v-if="!drawerToggle"
        ><i class="share-more-icon"></i>更多</span
      >
      <template v-if="drawerToggle">
        <span @click="shareJump('sinaWeibo')"
          ><i class="weibo-icon"></i>微博</span
        >
        <span @click="shareJump('qq')"><i class="qq-icon"></i>QQ</span>
        <span @click="shareJump('qZone')"
          ><i class="qqzone-icon"></i>QQ空间</span
        >
      </template>
    </div>
    <span
      class="share-drawer-btn d-flex justify-content-center align-items-center"
      @click="onToggleChange(false)"
      >取消</span
    >
  </div>
</template>

<script>
import * as utils from "@/utils/index";
import * as Api from "@/api/activity/inviteCashBack.js";

export default {
  props: {
    drawerToggle: {
      type: Boolean,
      default: false,
    },
    shareInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    shareJump(type) {
      let args = {
        platformType: type,
        ...this.shareInfo,
      };
      this.$igpJumpToNativeShare(JSON.stringify(args));
      this.recordLog(2);
    },
    recordLog(type) {
      let params = {};
      (params.page = type),
        (params.user_id = this.userID),
        (params.source = this.liveID ? "老师主页" : "个人中心");

      Api.recordLog(params)
        .then((res) => {
          utils.logic(res, (data) => {
            this.inviteRecords = data;
          });
        })
        .catch((err) => {
          this.$message.error("系统错误");
          throw Error(err);
        });
    },
    onToggleChange(bool) {
      this.$emit("update:drawerToggle", bool);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

.share-drawer {
  position: fixed;
  left: 0;
  right: 0;
  top: 100%;
  background-color: #fff;
  transform: translateY(0px);
  min-height: rem(170px);
  padding-top: rem(18px);
  .share-drawer-t {
    line-height: rem(33px);
    font-size: rem(24px);
    margin-bottom: rem(8px);
    color: #a2a2a2;
    text-align: center;
  }
  .share-drawer-content {
    span {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 0 0 25%;
      height: rem(170px);
      color: #7a7a7a;
      font-size: rem(24px);
      line-height: rem(33px);
      text-align: center;
    }
    i {
      display: block;
      margin: 0 auto;
      width: rem(80px);
      height: rem(80px);
      margin-bottom: rem(8px);
    }
  }
  .wechat-icon {
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/wechat_icon",
      "png"
    );
  }
  .friend-circle-icon {
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/friend_circle_icon",
      "png"
    );
  }
  .qrcode-icon {
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/qr_code_icon",
      "png"
    );
  }
  .share-more-icon {
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/share_more_icon",
      "png"
    );
  }
  .weibo-icon {
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/weibo",
      "png"
    );
  }
  .qq-icon {
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/qq_icon",
      "png"
    );
  }
  .qqzone-icon {
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/qqzone_icon",
      "png"
    );
  }
}

.show {
  border-radius: 0px;
  transition: all 0.1s linear;
  transform: translateY(rem(-195px));
}

.show-all {
  border-radius: rem(30px) rem(30px) 0px 0px;
  transition: all 0.1s linear;
  transform: translateY(-100%);
}

.share-drawer-btn {
  box-sizing: border-box;
  height: rem(100px);
  color: #7a7a7a;
  font-size: rem(32px);
  @include setTopLine(#e0e0e0);
}
</style>
